import { CustomerType } from 'models/CustomerType';
import { SiteMode } from 'models/SiteMode';

export { SiteModeSelector } from './siteModeSelector';
export { SalesTakerModal } from './themes/BGH/salesTakerModal';
export { SiteModeModal } from './themes/BGH/siteModeModal';
export { SiteModeChangedModal } from './themes/BGH/siteModeChangedModal';

export const customerTypeToSiteMode = (customerType: CustomerType) => {
  switch (customerType) {
    case CustomerType.Company:
    case CustomerType.Intercompany:
      return SiteMode.Company;
    case CustomerType.Private:
      return SiteMode.Private;
    default:
      return SiteMode.Unknown;
  }
};
